<template>
  <div>
    <h1 class="mb-8">Liste des clients</h1>

    <!-- champ de recherche  -->
    <v-text-field
      v-model="search"
      label="Filtre de recherche"
      placeholder="Rechercher..."
      autocomplete="false"
      outlined
    ></v-text-field>

    <!-- Data table -->
    <v-data-table
      :headers="headers"
      :items="clients"
      :items-per-page="15"
      class="elevation-1 mb-12"
      @click:row="goToClient"
      :search="search"
      sort-by="nom"
    >
      <template v-slot:item.action="{ item }">
        <v-icon
          color="orange"
          class="edit mr-7"
          @click.stop="editClient(item.id)"
          >mdi-pencil</v-icon
        >
        <v-icon
          color="red"
          class="delete"
          @click.stop="confirmerSuppression(item.id)"
          >mdi-delete</v-icon
        >
      </template>
    </v-data-table>

    <!-- Modal de confirmation  -->
    <v-dialog v-model="confirmerSupp" persistent max-width="490">
      <v-card>
        <v-card-title class="headline">Confirmer la suppression ?</v-card-title>
        <v-card-text>Cette action est définitive.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="confirmerSupp = false"
            >Annuler</v-btn
          >
          <v-btn color="red darken-1" text @click="supprimer">Confirmer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { db } from "@/firebase";

export default {
  name: "Dashboard",
  data: () => ({
    search: "",
    selectedClientId: "",
    confirmerSupp: false,
    headers: [
      {
        text: "Nom",
        align: "left",
        value: "nom",
      },
      { text: "Prénom", value: "prenom" },
      {
        text: "Ville",
        value: "ville",
      },
      {
        text: "Actions",
        value: "action",
        align: "right",
        sortable: false,
      },
    ],
  }),
  mounted() {
    //
  },
  computed: {
    clients() {
      return this.$store.state.clients;
    },
  },
  methods: {
    goToClient(client) {
      this.$router.replace({
        name: "ficheClient",
        params: { id: client.id },
      });
    },
    editClient(id) {
      this.$router.push({
        name: "editClient",
        params: { id: id, provenance: "dashboard" },
      });
    },
    confirmerSuppression(id) {
      this.selectedClientId = id;
      this.confirmerSupp = true;
    },
    async supprimer() {
      await db.doc("clients/" + this.selectedClientId).delete();
      this.confirmerSupp = false;
    },
  },
};
</script>

<style>
table tr {
  cursor: pointer;
}
</style>
